export const rollcallemployeesaccessdata = [
    {
        "sno": 1,
        "employee": "John Doe",
        "biometricid": "BIO12345",
        "mobile": "9876543210",
        "department": "IT Department",
        "empportalaccess": true
    },
    {
        "sno": 2,
        "employee": "Jane Smith",
        "biometricid": "BIO23456",
        "mobile": "8765432109",
        "department": "Human Resources",
        "empportalaccess": false
    },
    {
        "sno": 3,
        "employee": "Michael Brown",
        "biometricid": "BIO34567",
        "mobile": "7654321098",
        "department": "Finance",
        "empportalaccess": true
    },
    {
        "sno": 4,
        "employee": "Emily Johnson",
        "biometricid": "BIO45678",
        "mobile": "6543210987",
        "department": "Marketing",
        "empportalaccess": true
    },
    {
        "sno": 5,
        "employee": "David Wilson",
        "biometricid": "BIO56789",
        "mobile": "5432109876",
        "department": "Operations",
        "empportalaccess": false
    },
    {
        "sno": 6,
        "employee": "Sophia Davis",
        "biometricid": "BIO67890",
        "mobile": "4321098765",
        "department": "Customer Support",
        "empportalaccess": true
    },
    {
        "sno": 7,
        "employee": "James Taylor",
        "biometricid": "BIO78901",
        "mobile": "3210987654",
        "department": "Procurement",
        "empportalaccess": false
    },
    {
        "sno": 8,
        "employee": "Olivia Martinez",
        "biometricid": "BIO89012",
        "mobile": "2109876543",
        "department": "Product Development",
        "empportalaccess": true
    },
    {
        "sno": 9,
        "employee": "William Anderson",
        "biometricid": "BIO90123",
        "mobile": "1098765432",
        "department": "Research & Development",
        "empportalaccess": true
    },
    {
        "sno": 10,
        "employee": "Isabella White",
        "biometricid": "BIO01234",
        "mobile": "9876543201",
        "department": "Quality Assurance",
        "empportalaccess": false
    }
];
